import React, { useContext, useEffect, useState } from 'react';
import { Info, Person } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { AdminRoutes, RouteNames } from '../../../enums/RouteEnums';
import OverviewToolbar from '../../Common/Layout/OverviewToolbar';
import { AppBar, Box, Tab, Tabs } from '@mui/material';
import { Colors } from '../../../utils/theme';
import { getOuterStyle } from '../../../utils/styleUtils';
import { useGetUserLazyQuery } from '../../../generated/graphql';
import TabPanel from '../../Common/Layout/TabPanel';
import Loader from '../../Common/Loader';
import { AppContext } from '../../../AppContext';
import { Actions } from '../../../enums/ActionEnums';
import UserDetails from '../../Admin/Users/UserDetailsTab';

const UserInfoWrapper: React.FC = () => {
  const navigate = useNavigate();
  const { dispatch, state } = useContext(AppContext);
  const [value, setValue] = useState(0);
  const [getUser, { data, loading }] = useGetUserLazyQuery();
  const locationElements = location.pathname.split('/').filter((e) => e);

  useEffect(() => {
    if (!state.selectedUser) {
      getUser({
        variables: {
          id: parseInt(locationElements[locationElements.length - 1])
        }
      });
    }
  }, []);

  useEffect(() => {
    if (data && data.result) {
      dispatch({
        type: Actions.SetSelectedUser,
        payload: {
          user: data.result
        }
      });
    }
  }, [data]);

  const handleChange = (_: React.ChangeEvent<unknown>, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <OverviewToolbar
        handleToOverview={() => navigate(AdminRoutes.Users)}
        navName={RouteNames.AdminUsers}
      >
        <Person sx={{ marginRight: '7px' }} />
        {state.selectedUser?.username ?? ''}
      </OverviewToolbar>
      <Box>
        <AppBar position="static" sx={{ backgroundColor: 'white' }}>
          <Tabs
            value={value}
            onChange={handleChange}
            indicatorColor="primary"
            textColor="primary"
            variant="fullWidth"
            TabIndicatorProps={{ sx: { background: Colors.main } }}
          >
            <Tab
              id="membership-details"
              label={
                <Box>
                  <Info sx={{ verticalAlign: 'middle' }} /> Details
                </Box>
              }
              sx={getOuterStyle(0, value)}
            />
          </Tabs>
        </AppBar>
        {state.selectedUser ? (
          <Box>
            <TabPanel value={value} index={0}>
              <UserDetails />
            </TabPanel>
          </Box>
        ) : (
          <Loader loading={loading} />
        )}
      </Box>
    </Box>
  );
};

export default UserInfoWrapper;
